import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { DateTime } from 'luxon';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Notification } from '../interfaces/notification';
import {
  GeneralNotificationSettings,
  JobNotificationSetting,
  NotificationSetting,
} from '../interfaces/settings/notification-setting';

@Injectable({
  providedIn: 'root',
})
export class NotificationsAdapter {
  private http = inject(HttpClient);

  getNotifications(
    offset: number = 0,
    limit: number = -1,
    lastPoll?: DateTime
  ): Observable<{
    unseen: number;
    overall: number;
    notifications: Notification[];
  }> {
    const params = new HttpParams()
      .set('offset', offset.toString())
      .set('limit', limit.toString())
      .set('lastPoll', (lastPoll ?? DateTime.fromSeconds(0)).toISO());
    return this.http.get<{
      unseen: number;
      overall: number;
      notifications: Notification[];
    }>(`${environment.apiBaseUrl}/company/user/notifications`, {
      params,
    });
  }

  markAllAsSeen() {
    return this.http.patch(
      `${environment.apiBaseUrl}/company/user/notifications`,
      {}
    );
  }

  toggleState(notification: Notification) {
    return this.http.patch(
      `${environment.apiBaseUrl}/company/user/notifications/${notification.id}`,
      {
        type: notification.type,
        seen: !notification.seen,
      }
    );
  }

  getNotificationSettingsGeneral() {
    return this.http.get<GeneralNotificationSettings>(
      `${environment.apiBaseUrl}/company/user/notifications/settings/general`
    );
  }

  updateNotificationSettingsGeneral(settings: GeneralNotificationSettings) {
    return this.http.patch<GeneralNotificationSettings>(
      `${environment.apiBaseUrl}/company/user/notifications/settings/general`,
      settings
    );
  }

  getNotificationSettingsJobs() {
    return this.http.get<JobNotificationSetting[]>(
      `${environment.apiBaseUrl}/company/user/notifications/settings/jobs`
    );
  }

  updateNotificationSettingsJobs(settings: NotificationSetting[]) {
    return this.http.patch<JobNotificationSetting[]>(
      `${environment.apiBaseUrl}/company/user/notifications/settings/jobs`,
      { settings }
    );
  }

  markApplicationNotificationsAsRead(applicationId: number) {
    return this.http.patch(
      `${environment.apiBaseUrl}/company/user/notifications/application/${applicationId}`,
      {}
    );
  }
}
